import { render, staticRenderFns } from "./LegalSummary.vue?vue&type=template&id=1c45cc70&scoped=true&"
import script from "./LegalSummary.vue?vue&type=script&lang=js&"
export * from "./LegalSummary.vue?vue&type=script&lang=js&"
import style0 from "./LegalSummary.vue?vue&type=style&index=0&id=1c45cc70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45cc70",
  null
  
)

export default component.exports